
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[cName]/brands/[brandId]",
      function () {
        return require("private-next-pages/stores/[cName]/brands/[brandId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[cName]/brands/[brandId]"])
      });
    }
  